import axios from 'axios';
import {config} from '../shared/app.config';
import store from '../store/store';

const RESOURCE_NAME = '/webadmin/tickets';

export default {
  getAllByRestaurant (restaurant_id, tables, status, page, per_page, search, date_from, date_to, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    if (!page) page = 1;
    if (!per_page) per_page = 6;
    if (!search) search = '';

    return axios.post(`${config.webApiBase + RESOURCE_NAME  }/${  restaurant_id}`,
      {page, per_page, search, tables, status, date_from, date_to},
      {
        headers: {
          'X-localization': language
        }
      }
    );
  },
  getOne (id, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/one/${  id}`, {
      headers: {
        'X-localization': language
      }
    });
  },
  download (id, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios(`${config.webApiBase + RESOURCE_NAME  }/download/${  id}`, {
      method: 'GET',
      responseType: 'blob',
      headers: {
        'X-localization': language
      }
    });
  },
  getListSelectStatus (restaurants, language) {
    if (!language) language = store.getters.getCurrentLanguage;
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/status`, {
      headers: {
        'X-localization': language
      }
    });
  },
}
